import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import CourseList from './components/CourseList';
import ResultPage from './components/ResultPage';
import JudgmentResultPage from './components/JudgmentResultPage';
import { API_BASE_URL } from './config';
import './App.css';

function App() {
  const [courses, setCourses] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/courses/cs`);
        const data = await response.json();
        console.log('Fetched data:', data);
        setCourses(data);
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    };

    fetchCourses();
  }, []);

  const handleCourseSelect = (courseCode) => {
    setSelectedCourses(prev => {
      if (prev.includes(courseCode)) {
        return prev.filter(code => code !== courseCode);
      } else {
        return [...prev, courseCode];
      }
    });
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<HomePage />}
        />
        <Route
          path="/courses"
          element={
            <CourseList
              courses={courses}
              selectedCourses={selectedCourses}
              handleCourseSelect={handleCourseSelect}
            />
          }
        />
        <Route
          path="/result"
          element={
            <ResultPage
              courses={courses}
              selectedCourses={selectedCourses}
            />
          }
        />
        <Route
          path="/judgment"
          element={<JudgmentResultPage />}
        />
      </Routes>
    </Router>
  );
}

export default App;
